import { useEffect, useState } from "react";

const ALIASES = {
    bhuj: ["bhuj", "kutch", "kukma", "gandhidham", "madhapar", "anjar", "mirzapar"],
    mumbai: ["mumbai", "bombay", "thane", "navi mumbai"],
    bengaluru: ["bengaluru", "bangalore"],
    "delhi-ncr": [
        "delhi",
        "new delhi",
        "gurugram",
        "gurgaon",
        "noida",
        "ghaziabad",
        "faridabad",
    ],
    hyderabad: ["hyderabad", "secunderabad"],
    pune: ["pune", "pimpri"],
    ahmedabad: ["ahmedabad", "gandhinagar"],
    chennai: ["chennai", "madras"],
    kolkata: ["kolkata", "howrah", "calcutta"],
};

export function matchCity(name) {
    if (!name) return null;
    const n = String(name).toLowerCase();
    for (const [slug, aliases] of Object.entries(ALIASES)) {
        if (aliases.some((a) => n.includes(a))) return slug;
    }
    return null;
}

let pending = null;

export function useApproxCity() {
    const [state, setState] = useState(() => {
        try {
            const cached = sessionStorage.getItem("sthaan.geo");
            if (cached) return JSON.parse(cached);
        } catch (e) {}
        return { loading: true, detected: null, slug: null };
    });

    useEffect(() => {
        if (!state.loading) return;
        if (!pending) {
            pending = fetch("https://ipapi.co/json/")
                .then((r) => r.json())
                .then((d) => ({
                    detected: d && d.city ? d.city : null,
                    slug: matchCity(d && d.city),
                }))
                .catch(() => ({ detected: null, slug: null }));
        }
        let active = true;
        pending.then((g) => {
            const value = { loading: false, ...g };
            try {
                sessionStorage.setItem("sthaan.geo", JSON.stringify(value));
            } catch (e) {}
            if (active) setState(value);
        });
        return () => {
            active = false;
        };
    }, [state.loading]);

    return state;
}
